module.exports = __webpack_public_path__ + "img/download.713c0c90.svg";